import { cn } from "../../utils/styling";

interface ToggleProps {
  options: [{ label: string; value: string }, { label: string; value: string }];
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

export function Toggle({ options, value, onChange, className }: ToggleProps) {
  const [option1, option2] = options;
  const isFirstSelected = value === option1.value;

  return (
    <div
      className={cn(
        "relative w-full max-w-xs py-2 bg-surface-one rounded-full",
        className,
      )}
    >
      {/* Background slider */}
      <div
        className={cn(
          "absolute top-0 bottom-0 w-1/2 bg-brand-primary rounded-full transition-all duration-200 ease-in-out",
          isFirstSelected ? "left-0" : "left-[calc(50%)]",
        )}
      />
      {/* Option buttons */}
      <div className="relative flex h-full">
        <button
          onClick={() => onChange(option1.value)}
          className={cn(
            "flex-1 flex items-center justify-center rounded-full text-sm font-medium transition-colors duration-200 z-10",
            isFirstSelected ? "text-white" : "text-brand-primary",
          )}
        >
          {option1.label}
        </button>
        <button
          onClick={() => onChange(option2.value)}
          className={cn(
            "flex-1 flex items-center justify-center rounded-full text-sm font-medium transition-colors duration-200 z-10",
            !isFirstSelected ? "text-white" : "text-brand-primary",
          )}
        >
          {option2.label}
        </button>
      </div>
    </div>
  );
}
